import { select } from '../../shared/utils/dom';
import { keyCodes } from '../../shared/constants/keyboard';
import dataLayerPush from '../../shared/utils/analytics'

class SearchModal {
  constructor() {
    this.desktopTrigger = select('.SearchModalDesktopTrigger');
    this.searchModal = select('.SearchModal');
    this.searchInput = select('#modal-search-input');
    this.searchButton = select('#modal-search');
    this.mobileNav = select('.MobileNav');
    this.mobileHeader = select('.SiteHeader--mobile');
    this.desktopHeader = select('.SiteHeader--desktop');
    this.mobileTrigger = select('.SearchModalMobileTrigger');
    this.closeSearchModal = select('.SearchModal .CloseModal');
    if (this.searchModal) {
      this.openModal = this.openModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.clickEvent = this.clickEvent.bind(this);
      this.searchTerm = this.searchTerm.bind(this);
    }
    this.bindEvents();
  }

  /**
   * Add event listeners
   */
  bindEvents() {
    // mouse events enter and leave
    if (this.searchModal) {
      if (this.desktopTrigger) {
        this.desktopTrigger.addEventListener('click', this.openModal);
      }
      if (this.mobileTrigger) {
        this.mobileTrigger.addEventListener('click', this.openModal);
      }
      this.searchInput.addEventListener('keypress', (event) => {
        if (event.keyCode === keyCodes.enter) {
          this.searchTerm();
        }
      });
      this.searchButton.addEventListener('click', this.searchTerm);
    }
  }

  /**
   * Open the modal
   */
  openModal() {
    this.searchModal.classList.add('is-open');
    this.adjustPosition();
    this.searchInput.focus();
    document.addEventListener('click', this.clickEvent);
    this.searchModal.addEventListener('mouseleave', this.closeModal);
    if (this.mobileNav) {
      this.mobileNav.addEventListener('scroll', this.closeModal);
    }
    if (this.closeSearchModal) {
      this.closeSearchModal.addEventListener('click', this.closeModal);
    }
  }

  adjustPosition() {
    if (this.desktopHeader && this.desktopHeader.clientHeight !== 0) {
      const desktopHeaderClientRect = this.desktopHeader.getBoundingClientRect();
      this.searchModal.style.top = `calc(${desktopHeaderClientRect.top + desktopHeaderClientRect.height}px)`;
    }
    if (this.mobileHeader && this.mobileHeader.clientHeight !== 0) {
      const mobileHeaderClientRect = this.mobileHeader.getBoundingClientRect();
      this.searchModal.style.top = `calc(${(mobileHeaderClientRect.top + mobileHeaderClientRect.height) - 1}px)`;
    }
  }

  closeModal() {
    this.searchModal.classList.remove('is-open');
    document.removeEventListener('click', this.clickEvent);
    window.removeEventListener('scroll', this.closeModal);
    this.searchModal.removeEventListener('mouseleave', this.closeModal);
    if (this.mobileNav) {
      this.mobileNav.removeEventListener('scroll', this.closeModal);
    }
    if (this.closeSearchModal) {
      this.closeSearchModal.removeEventListener('click', this.closeModal);
    }
  }

  clickEvent(event) {
    if (event && event.srcElement && !(event.srcElement.closest('.SearchModalDesktopTrigger') || event.srcElement.closest('.SearchModal') || event.srcElement.closest('.SearchModalMobileTrigger'))) {
      this.closeModal();
    }
  }

  searchTerm() {
    const searchText = this.searchInput.value;
    if (searchText && searchText.trim() !== '') {
      dataLayerPush('SearchResultsSearchTerm');
      window.open(`/search-results#/?term=${searchText.trim()}`, '_self');
    }
  }
}

// export functionality since it could be used more than once.
export default function () {
  new SearchModal(); // eslint-disable-line no-new
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/marketing/vue/searchModal.js